// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M13.2 2.65A2 2 0 0 0 10.8 2.65L3.8 7.9A2 2 0 0 0 3 9.5V19A2 2 0 0 0 5 21H8.9A1.1 1.1 0 0 0 10 19.9V15A2 2 0 1 1 14 15V19.9A1.1 1.1 0 0 0 15.1 21H19A2 2 0 0 0 21 19V9.5A2 2 0 0 0 20.2 7.9Z"/>';

/** Home (navigation). */
const icon: IconData = {
  id: "home",
  name: "Home",
  category: "navigation",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path fill="none" stroke="currentColor" stroke-width="2" d="M4 9.5A1 1 0 0 1 4.4 8.7L11.4 3.45A1 1 0 0 1 12.6 3.45L19.6 8.7A1 1 0 0 1 20 9.5V19A1 1 0 0 1 19 20H14.1A.1.1 0 0 1 14 19.9V14A2 2 0 1 0 10 14V19.9A.1.1 0 0 1 9.9 20H5A1 1 0 0 1 4 19Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M12.16 2.26L12.78 2.41 13.2 2.65 20.37 8.06 20.66 8.41 20.87 8.82 21 9.5 20.98 19.2 20.75 19.95 20.27 20.54 19.59 20.9 19 21H14.1L13.71 20.92 13.29 20.61 13.07 20.27 13 19.9V14.1L12.9 13.62 12.69 13.31 12.38 13.1 12 13.02 11.62 13.1 11.31 13.31 11.1 13.62 11 14.1V19.9L10.92 20.29 10.61 20.71 10.28 20.93 9.9 21 4.8 20.98 4.05 20.75 3.46 20.27 3.1 19.59 3 19 3.03 9.27 3.13 8.82 3.34 8.41 3.8 7.9 10.94 2.56 11.53 2.31Z"/></g><path fill="none" stroke="currentColor" stroke-width="2" d="M4 9.5A1 1 0 0 1 4.4 8.7L11.4 3.45A1 1 0 0 1 12.6 3.45L19.6 8.7A1 1 0 0 1 20 9.5V19A1 1 0 0 1 19 20H14.1A.1.1 0 0 1 14 19.9V14A2 2 0 1 0 10 14V19.9A.1.1 0 0 1 9.9 20H5A1 1 0 0 1 4 19Z"/>',
    },
  },
  animation: () => import("../animations/home.js"),
};

export default icon;
